import _objectWithoutProperties from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children", "active"],
    _excluded2 = ["items"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import React, { Fragment } from "react";
import { bool, func, string } from "prop-types";
import Styled from "styled-components"; // Colors

import { backgrounds, extended, primary } from "@uprise/colors";
var ProgressStyles = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n"])));
var ItemTitle = Styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      font-family: ", ";\n      top: ", ";\n      position: relative;\n      width: 100%;\n\n      &:after {\n            content: \" \";\n            display: ", ";\n            border-top-left-radius: 2px;\n            border-bottom-left-radius: 2px;\n            position: absolute;\n            right: 0;\n            width: 4px;\n            height: 21px;\n            background-color: ", ";\n      }\n"])), function (props) {
  return props.active ? "Proxima Nova Semibold" : "Proxima Nova";
}, function (props) {
  return props.active ? "2px" : "0px";
}, function (props) {
  return props.active ? "inline-block" : "none";
}, function (props) {
  return props.active ? primary.purple : extended.charcoal.one;
});
var ProgressItemStyles = Styled.section(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      display: flex;\n      height: 51px;\n      font-size: 15px;\n      border-right: 1px solid ", ";\n      background-color: ", ";\n      color: ", ";\n      padding-top: 1rem;\n"])), extended.purple.five, function (props) {
  return props.active ? backgrounds.fadedPurple : backgrounds.white;
}, function (props) {
  return props.active ? primary.purple : extended.charcoal.one;
});
var OvalActiveStyles = Styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      width: 22px;\n      height: 17px;\n      border: solid 3px ", ";\n      background-color: ", ";\n      border-radius: 50%;\n      display: inline-block;\n      margin-right: 18px;\n      margin-left: 46px;\n      top: 3px;\n      position: relative;\n\n\n      &:after {\n            content: \" \";\n            width: 1px;\n            height: 43px;\n            display: ", ";\n            background-color: ", ";\n            margin-top: 14px;\n            margin-left: 5px;\n      }\n"])), primary.purple, backgrounds.fadedPurple, function (props) {
  return props.last ? "none" : "block";
}, extended.charcoal.four);
var OvalStyles = Styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      width: 14px;\n      height: 9px;\n      background-color: ", ";\n      border-radius: 50%;\n      display: inline-block;\n      margin-right: 18px;\n      margin-left: 50px;\n      top: 4px;\n      position: relative;\n\n      &:after {\n            content: \" \";\n            width: 1px;\n            height: 43px;\n            display: ", ";\n            background-color: ", ";\n            margin-top: 10px;\n            margin-left: 4px;\n      }\n"])), extended.charcoal.three, function (props) {
  return props.last ? "none" : "block";
}, extended.charcoal.four);

var ProgressItem = function ProgressItem(_ref) {
  var children = _ref.children,
      active = _ref.active,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ProgressItemStyles, {
    active: active
  }, children);
};

ProgressItem.propTypes = {
  active: bool.isRequired
};
ProgressItem.defaultProps = {
  active: false
};
export var VerticalProgress = function VerticalProgress(_ref2) {
  var items = _ref2.items,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(ProgressStyles, props, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ProgressItem, {
      key: index,
      active: item.active
    }, /*#__PURE__*/React.createElement(Fragment, null, item.active && /*#__PURE__*/React.createElement(OvalActiveStyles, {
      last: index === items.length - 1
    }), !item.active && /*#__PURE__*/React.createElement(OvalStyles, {
      last: index === items.length - 1
    }), /*#__PURE__*/React.createElement(ItemTitle, {
      active: item.active
    }, item.title)));
  }));
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

VerticalProgress.propTypes = {
  className: string,
  color: string,
  width: string,
  textAlign: string
};
VerticalProgress.defaultProps = {
  className: "",
  color: primary.charcoal,
  width: "",
  textAlign: ""
};